import {Card, Separator} from 'platform/components';

import {
  VehicleFormDefaultLayout,
  VehicleSubSections as VFSubSection,
} from '@dms/features/vehicle-forms-kit';

export function ServiceIntervals() {
  return (
    <VehicleFormDefaultLayout>
      <VehicleFormDefaultLayout.Left>
        <Card variant="inlineGrey">
          <VFSubSection.ServiceInspectionReplacement />
          <Separator />
          <VFSubSection.EngineOilReplacement />
          <Separator />
          <VFSubSection.GearboxOilReplacement />
          <Separator />
          <VFSubSection.FourByFourOilDistributorReplacement />
          <Separator />
          <VFSubSection.TimingBeltReplacement />
          <Separator />
          <VFSubSection.BrakeFluidReplacement />
          <Separator />
          <VFSubSection.CoolantFluidReplacement />
        </Card>
      </VehicleFormDefaultLayout.Left>
    </VehicleFormDefaultLayout>
  );
}
